/**
 * UX-C2 (#295 W06 · UX-29/30/52) — บริบทสำหรับฟอร์มบนหน้าการ์ด (staff · read-only)
 * endpoint: GET /api/v1/tickets/:id/compose-context (additive — ห้ามแตะ schema/สิทธิ์เดิม)
 *
 * - ComposeField: field definition แบบ typed ตาม scope ของการ์ด (global + service + holder team · ไม่ archived)
 *   ให้เว็บวาด input ตามชนิด + validation และคงชนิดค่าเดิม (boolean/number/array ไม่กลายเป็น string)
 * - ComposeTransitionRequirements: สิ่งที่ transition บังคับก่อนเปลี่ยนสถานะ (note/required fields/
 *   children closed) — ชุด to_status_code เดียวกับ allowed_transitions ของ GET /tickets/:id
 */
import { z } from "zod";

const I18nRecord = z.record(z.string(), z.string());

export const ComposeField = z.object({
  key: z.string(),
  label: I18nRecord,
  type: z.string(),
  /** ตัวเลือกของ select/multiselect — แถว { value, label } ตามที่ admin สร้าง (passthrough ไม่ตีความซ้ำ) */
  options: z.array(z.unknown()).nullable(),
  /** { regex?, min?, max? } ตาม field_definitions.validation */
  validation: z.record(z.string(), z.unknown()).nullable(),
  scope_type: z.enum(["global", "service", "team"]),
  customer_editable: z.boolean(),
  /** ข้อมูลอ่อนไหว (PDPA) — UI ทำเครื่องหมาย/จำกัดการโชว์ตามสิทธิ์ */
  sensitive: z.boolean(),
});
export type ComposeField = z.infer<typeof ComposeField>;

export const ComposeTransitionRequirements = z.object({
  to_status_code: z.string(),
  /** [T-067] ต้องอนุมัติก่อน — UI อธิบาย "รออนุมัติ" ก่อนยืนยัน */
  requires_approval: z.boolean(),
  require_note: z.boolean(),
  required_fields: z.array(z.string()),
  require_children_closed: z.boolean(),
});
export type ComposeTransitionRequirements = z.infer<typeof ComposeTransitionRequirements>;

export const TicketComposeContext = z.object({
  service_id: z.uuid(),
  fields: z.array(ComposeField),
  transitions: z.array(ComposeTransitionRequirements),
});
export type TicketComposeContext = z.infer<typeof TicketComposeContext>;
